/**
 * Constructs the full image URL from a relative path
 * Handles both local and production environments
 *
 * @param imageUrl - The relative image URL from the backend (e.g., "uploads/id/file.jpg" or "id/file.jpg")
 * @param fallbackUrl - Optional fallback URL if imageUrl is not provided
 * @returns The full image URL ready to use in img src
 */
export const getImageUrl = (
	imageUrl?: string,
	fallbackUrl?: string,
): string => {
	// Return fallback if no image URL provided
	if (!imageUrl) {
		return fallbackUrl || '';
	}

	// If already a full URL (http/https), return as-is
	if (imageUrl.startsWith('http')) {
		return imageUrl;
	}

	const baseUrl = process.env.REACT_APP_STORAGE_BASE_URL || '';
	const uploadsPath = process.env.REACT_APP_UPLOADS_PATH || 'uploads';

	// Ensure the URL includes the uploads path prefix
	const urlWithPrefix = imageUrl.startsWith(`${uploadsPath}/`)
		? imageUrl
		: `${uploadsPath}/${imageUrl}`;

	// Remove trailing slash from baseUrl if present, and ensure proper joining
	const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
	const cleanPath = urlWithPrefix.startsWith('/')
		? urlWithPrefix
		: `/${urlWithPrefix}`;

	return `${cleanBaseUrl}${cleanPath}`;
};
